import { render, staticRenderFns } from "./ImportPupilsDialog.vue?vue&type=template&id=6b3489c8&scoped=true"
import script from "./ImportPupilsDialog.vue?vue&type=script&lang=ts"
export * from "./ImportPupilsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3489c8",
  null
  
)

export default component.exports